import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '@/views/HomePage/HomePage.vue';
import AppointmentsCalendarPage from '../views/AppointmentsCalendarPage/AppointmentsCalendarPage.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/sero-survey',
    name: 'SeroSurveyPage',
    component: () => import('../views/SeroSurveyPage/SeroSurveyPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sero-survey-complete',
    name: 'SeroSurveyCompletePage',
    component: () => import('../views/SeroSurveyPage/SeroSurveyCompletePage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/create-user',
    name: 'CreateUser',
    component: () => import('../views/SeroSurveyPage/CreateUser.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/locations',
    name: 'Locations',
    component: AppointmentsCalendarPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/appointments/:location',
    name: 'Appointments',
    component: AppointmentsCalendarPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/appointment/:selectedDate/:minDate/:maxDate/:location',
    name: 'AppointmentsSelectedDayPage',
    component: () => import('../views/AppointmentsSelectedDayPage/AppointmentsSelectedDayPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Registration/RegistrationForm.vue'),
    meta: {
      requiresAuth: false
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // We wait for Keycloak init, then we can call all methods safely

    while (store.getters.authenticated == null) {
      await sleep(100);
    }

    if (store.getters.authenticated) {
      next();
    } else {
      const authUrl = store.state.keycloak.createLoginUrl({
        redirectUri: window.location.origin + to.path
        //scope: 'offline_access'
      });

      window.location.href = authUrl;
    }
  } else {
    next();
  }
});

export default router;
